import useSWR from 'swr';
import { getVehicleCacheKey } from '@/constants/cache-keys';
import { EngineService } from '@/services/engine';
import type { Vehicle } from '@/types';
import { useVehicleIdentityActions } from '@/features/IdentityActions';
import type { EntityActionModalsProps } from './types';
import { useOpenOnce } from './useOpenOnce';

export function VehicleActionModals({
    entityId,
    actionKind,
    onClose,
    onChanged,
}: EntityActionModalsProps) {
    const { data: vehicle, mutate } = useSWR<Vehicle>(
        getVehicleCacheKey(entityId),
        () => EngineService.getVehicle(entityId),
        { revalidateOnFocus: false },
    );
    const { modals, openAction } = useVehicleIdentityActions({
        vehicle,
        includeDelete: false,
        mutateDetail: mutate,
        onChanged,
        onDeleted: onClose,
        onMerged: onClose,
        onSourceStale: onClose,
    });
    useOpenOnce(Boolean(vehicle), async () => {
        await openAction(actionKind);
        if (actionKind === 'markAsUnknown') {
            onClose();
        }
    });

    return <>{modals}</>;
}
